module.exports = __webpack_public_path__ + "static/labeling-e9decf3edddd4cdc52e3b2ef021ba44f.svg";